import { Icon, Box, BoxTitle, Indication } from './styles';
import InnerLoader from 'components/InnerLoader';

const SearchingListingsBox = () => {
    return (
        <Box>
            <BoxTitle>
                Searching for listings with a label containing this dealer’s CMS ID.
            </BoxTitle>
            <Indication>
                <Icon>
                    <InnerLoader />
                </Icon>
            </Indication>
        </Box>
    )
}

export default SearchingListingsBox